import React, { useContext } from 'react';
import { WizardContext } from 'context/Context';

const SplashAtFODS = () => {
  const { job } = useContext(WizardContext);

  return job?.faRelease && job?.bsTextFODS ? (
    <>
      <hr />
      <h5>Backsplash</h5>
      <p>{job?.bsTextFODS}</p>
    </>
  ) : null;
};

export default SplashAtFODS;
